<template>
    <b-modal
        id="bankAccount"
        :active="isActFinanceAcc"
        @update:active="SET_IS_ACT_FINANCE_ACC(false)"
    >
        <div class="card" id="bankAccountCard">
            <header class="modal-card-head has-background-white">
                <p class="modal-card-title has-text-centered">
                    Cuenta bancaria
                </p>
                <button
                    class="delete"
                    aria-label="Cerrar Modal"
                    @click="SET_IS_ACT_FINANCE_ACC(false)"
                ></button>
            </header>
            <section class="modal-card-body">
                <p class="mt-2 mb-5 has-text-centered">
                    Actualizar el saldo de tus cuentas te permite generar una
                    mejor proyección de caja.
                </p>
                <b-tabs type="is-boxed" v-model="activeTab">
                    <b-tab-item icon="eye" label="Ver cuentas">
                        <BankList
                            :accountsList="financialEntityAccList"
                            :changeTab="changeTab"
                            :showNewAccountTag="showNewAccountTag"
                            @on-update-manual-amount="onUpdateManualAmount"
                            @on-confirm-disconnect="onConfirmDisconnect"
                            @on-confirm-delete="onConfirmDelete"
                            :isLoading="bankListIsloading"
                        />
                    </b-tab-item>
                    <b-tab-item
                        icon="plus-circle"
                        label="Agregar cuenta automática"
                    >
                        <AutomaticUpload
                            :loadingFintoc="widgetIsLoading"
                            @on-connect="openWidget"
                            :isSuccessful="addAutomaticIsSuccessful"
                            :widgetSuccessfull="widgetSuccessfull"
                        />
                    </b-tab-item>
                    <b-tab-item
                        icon="plus-circle"
                        label="Agregar cuenta manual"
                    >
                        <ManualUpload
                            :financialEntityList="financialEntityList"
                            @on-add-manual-amount="onAddManualAmount"
                            :isLoading="addManualIsLoading"
                            :isSuccessful="addManualIsSuccessful"
                        />
                    </b-tab-item>
                </b-tabs>
            </section>
        </div>
    </b-modal>
</template>

<script>
import { getFintocToken, saveFintocUserHolder } from "@/api/fintoc";
import config from "@/config";
import { consoleHandlerError, notificate } from "@/utils/message";
import { mapActions, mapMutations, mapState } from "vuex";
import AutomaticUpload from "./automaticUpload";
import BankList from "./bankList/bankList";
import ManualUpload from "./manualUpload";

export default {
    name: "BankAccounts",
    components: {
        BankList,
        AutomaticUpload,
        ManualUpload,
    },
    data() {
        return {
            widget: () => {},
            widgetIsLoading: false,
            widgetSuccessfull: true,
            widgetEvent: null,
            activeTab: 0,
            bankListIsloading: false,
            addManualIsLoading: false,
            addManualIsSuccessful: false,
            addAutomaticIsSuccessful: false,
            showNewAccountTag: false,
        };
    },
    methods: {
        ...mapActions("financialEntity", [
            "createFinanceEntity",
            "updateFinanceEntity",
            "deleteFinanceEntity",
            "disconnectFinanceEntity",
            "getFinanceEntitys",
            "getBankMovements",
        ]),
        ...mapActions("graphCashFlow", ["getForecastFlowCash"]),
        ...mapActions("userAuth", ["refreshSession"]),
        ...mapMutations("financialEntity", [
            "SET_IS_ACT_FINANCE_ACC",
            "SET_IS_DOWNLOAD_MOVEMENTS",
            "SET_HAS_AUTOMATIC_ACCOUNTS",
        ]),
        // WIDGET METHODS
        openWidget() {
            this.widgetIsLoading = true;
            if (this.widget.destroy !== undefined) {
                this.widget.destroy();
                this.widget = () => {};
            }
            getFintocToken({ product_type: "movements" })
                .then((response) => {
                    this.widget = window.Fintoc.create({
                        holderType: "business",
                        product: "movements",
                        publicKey: response.data.public_key,
                        webhookUrl: `${config.webhookAPI}/fintoc_app/link_token/?token=${response.data.webhook_token}`,
                        onSuccess: (link) =>
                            this.onWidgetSuccess(
                                response.data["company_product_link"]["id"],
                                link
                            ),
                        onExit: () => this.onWidgetExit(),
                    });
                    this.SET_IS_ACT_FINANCE_ACC(false);
                    this.widget.open();
                    this.widgetIsLoading = false;
                })
                .catch(() => {
                    this.widgetSuccessfull = false;
                });
        },
        onWidgetExit() {
            this.widget.destroy();
            this.SET_IS_ACT_FINANCE_ACC(true);
        },
        async onWidgetSuccess(id, linkp) {
            this.SET_IS_ACT_FINANCE_ACC(true);
            this.widgetSuccessfull = true;
            this.addAutomaticIsSuccessful = true;
            this.showNewAccountTag = true;
            linkp["company_product_link_id"] = id;
            await saveFintocUserHolder(linkp);

            await this.refreshSession();
            setTimeout(() => {
                this.activeTab = 0;
                this.addAutomaticIsSuccessful = false;
                this.SET_IS_DOWNLOAD_MOVEMENTS(true);
                this.SET_HAS_AUTOMATIC_ACCOUNTS(true);
                notificate(
                    `Estamos sincronizando las nuevas cuentas y saldos,<br>
                    <b>esto puede tardar algunos minutos.</b>`,
                    "is-success is-light",
                    "is-top-left",
                    true
                );
                setTimeout(() => {
                    this.getFinanceEntitys();
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    this.getBankMovements().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                }, 720000);
            }, 2000);
        },

        // MODAL METHODS
        changeTab(tab) {
            if (tab === "manual") this.activeTab = 2;
            else if (tab === "automatic") this.activeTab = 1;
        },
        onUpdateManualAmount(data) {
            this.bankListIsloading = true;
            this.updateFinanceEntity(data)
                .then(() => {
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                })
                .catch((error) => {
                    consoleHandlerError({ error });
                })
                .finally(() => {
                    this.bankListIsloading = false;
                    this.showNewAccountTag = false;
                });
        },
        onConfirmDisconnect(data) {
            this.bankListIsloading = true;
            this.disconnectFinanceEntity(data)
                .then(() => {
                    this.getFinanceEntitys();
                })
                .catch((error) => {
                    consoleHandlerError({ error });
                })
                .finally(() => {
                    this.bankListIsloading = false;
                    this.showNewAccountTag = false;
                });
        },
        onConfirmDelete(data) {
            this.bankListIsloading = true;
            this.deleteFinanceEntity(data)
                .then(() => {
                    this.getFinanceEntitys();
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                })
                .catch((error) => {
                    consoleHandlerError({ error });
                })
                .finally(() => {
                    this.bankListIsloading = false;
                    this.showNewAccountTag = false;
                });
        },
        onAddManualAmount(data) {
            this.addManualIsLoading = true;
            this.createFinanceEntity(data)
                .then(() => {
                    this.addManualIsSuccessful = true;
                    this.getForecastFlowCash().catch((error) => {
                        consoleHandlerError({ error, empty: true });
                    });
                    setTimeout(() => {
                        this.activeTab = 0;
                        this.addManualIsSuccessful = false;
                    }, 2000);
                })
                .catch((error) => {
                    this.addManualIsLoading = false;
                    consoleHandlerError({ error });
                })
                .finally(() => {
                    this.showNewAccountTag = true;
                    this.addManualIsLoading = false;
                });
        },
    },
    computed: {
        ...mapState("financialEntity", [
            "financialEntityAccList",
            "isActFinanceAcc",
            "financialEntityList",
        ]),
    },
};
</script>
